import {DeviceSlaveSettings} from "../../../../../../../ReadAndWrite/data/models/DeviceSlaveSetting";
import {RestDataLoader} from "../../../../../../../dashboard/widgets/unilever/RestDataLoader";

export function updateEquipmentStatus(equipmentGuid: string, statusGuid: string): Promise<DeviceSlaveSettings> {
    return new Promise<DeviceSlaveSettings>((res, rej) => {
        const parameters = {
            guid: statusGuid
        }
        RestDataLoader.putJSON(
            `equipment/${equipmentGuid}/status`,
            parameters,
            res,
            rej
        )
    })
}


export function registerTheVisit(equipmentGuid: string, date?: string, notes?: string): Promise<any> {
    return new Promise<any>((res, rej) => {
        const parameters = {
            date,
            notes
        }
        RestDataLoader.putJSON(
            `equipment/${equipmentGuid}/visit${RestDataLoader.objToUrlParams(Object.keys(parameters), parameters)}`,
            {},
            res,
            rej
        )
    })
}